import { cn } from "../lib/cn";

type SpinnerProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
};

const sizeMap = { sm: 16, md: 24, lg: 36 };

export function Spinner({ size = "md", className, label = "Loading" }: SpinnerProps) {
  const px = sizeMap[size];
  return (
    <svg
      className={cn("cf-spinner", className)}
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={label}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="var(--cf-opacity-spinner-track)"
      />
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
